import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SkeletonVideoCard from '../../components/skeleton/SkeletonVideoCard';
import VideoCard from '../../components/common/VideoCard';
import useSelectVideo from '../../hooks/useSelectVideo';
import { getOtherUserReshare } from '../../redux/ApiSlice/ResharedSlice';

export function OtherUserReposts({ userId, filteredByResharedPosts, reSharedList, loading, hasMore, error }) {
    const [pageCount, setPageCount] = useState(1);
    const [isLoadingMore, setIsLoadingMore] = useState(false);

    const dispatch = useDispatch();
    const selectVideo = useSelectVideo();

    // const { reSharedList, loading, hasMore, error } = useSelector((state) => state.resharedPosts);

    // const filteredByResharedPosts = reSharedList?.reposts?.map((item) => (item.original_post));

    const handleSelectVideo = async (id) => {
        selectVideo(id, filteredByResharedPosts);
    };

    // Load initial data
    useEffect(() => {
        if (userId) {
            // dispatch(getOtherUserReshare({ userId: userId, pageCount: 1 }));
            setPageCount(1);
        }
    }, [dispatch, userId]);

    // Load more data for pagination
    const loadMoreData = useCallback(async () => {
        if (hasMore && !loading && !isLoadingMore && userId) {
            setIsLoadingMore(true);
            const nextPage = pageCount + 1;
            // await dispatch(getOtherUserReshare({ userId: userId, pageCount: nextPage }));
            setPageCount(nextPage);
            setIsLoadingMore(false);
        }
    }, [dispatch, hasMore, loading, isLoadingMore, pageCount, userId]);

    // Infinite scroll handler
    const handleScroll = useCallback((e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;
        if (scrollHeight - scrollTop <= clientHeight + 100) {
            loadMoreData();
        }
    }, [loadMoreData]);

    if (loading && pageCount === 1) {
        return <SkeletonVideoCard />;
    }

    if (reSharedList?.length === 0 && !loading) {
        return (
            <div className="flex justify-center items-center h-64">
                <p className="text-[12px] text-gray-400 dark:text-gray-500">
                    No reposts yet.
                </p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="flex justify-center items-center h-64">
                <p className="text-[12px] text-red-500">
                    Error loading posts. Please try again.
                </p>
            </div>
        );
    }

    return (
        <div
            className="grid grid-cols-3 p-2 gap-1 overflow-y-scroll h-full"
            onScroll={handleScroll}
        >
            {reSharedList?.map((item) => (
                <VideoCard
                    key={item.original_post.id}
                    id={item.original_post.id}
                    belowDecs={true}
                    body={item.original_post.post_description}
                    threeDots={false}
                    video={item.original_post.video_url}
                    user_id={item.original_post.created_by?.id}
                    authorId={item.original_post.created_by?.id}
                    view_count={item.original_post.view_count}
                    likes_count={item.original_post.likes_count}
                    selectVideo={handleSelectVideo}
                    avatar_url={item.original_post.created_by?.avatar_url}
                    thumbnail={item.original_post.thumbnail_url}
                />
            ))}
            {(isLoadingMore || (loading && pageCount > 1)) && (
                <div className="col-span-2 flex justify-center items-center py-4">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
                </div>
            )}
        </div>
    );
}
